import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// =========================================================================
// UNIFIED DATA STRUCT TYPE CONTEXT MODELS
// =========================================================================
export interface SysNumberSequence {
      id?: string;
      entityName: string;
      transactionType?: string;
      code: string;
      name?: string;
      prefix?: string;
      suffix?: string;
      separator?: string;
      padding: number;
      nextNumber: number;
      incrementBy: number;
      resetType?: string;
      financialYear: boolean;
      branchWise: boolean;
      orgWise: boolean;
      isActive?: boolean;
}

export interface SysNumberSequenceCounter {
      id?: string;
      sequenceId: string;
      orgId?: string;
      branchId?: string;
      financialYear?: string;
      currentNumber: number;
}

@Injectable({
      providedIn: 'root'
})
export class SysNumberSequenceService {
      // Update port matching your local running framework
      private baseUrl = 'https://localhost:7056/api/sys-number-sequence';

      constructor(private http: HttpClient) { }

      // ---------------------------------------------------------------------
      // SEQUENCE BASE PERSISTENCE METHODS
      // ---------------------------------------------------------------------
      getAllSequences(): Observable<SysNumberSequence[]> {
            return this.http.get<SysNumberSequence[]>(this.baseUrl);
      }

      getSequenceById(id: string): Observable<SysNumberSequence> {
            return this.http.get<SysNumberSequence>(`${this.baseUrl}/${id}`);
      }

      createSequence(dto: SysNumberSequence): Observable<any> {
            return this.http.post(this.baseUrl, dto);
      }

      updateSequence(id: string, dto: SysNumberSequence): Observable<any> {
            return this.http.put(`${this.baseUrl}/${id}`, dto);
      }

      deleteSequence(id: string): Observable<any> {
            return this.http.delete(`${this.baseUrl}/${id}`);
      }

      // ---------------------------------------------------------------------
      // RUNTIME STEP COUNTER TRACK METRICS METHODS
      // ---------------------------------------------------------------------
      getAllCounters(): Observable<SysNumberSequenceCounter[]> {
            return this.http.get<SysNumberSequenceCounter[]>(`${this.baseUrl}/counters`);
      }

      getCounterById(id: string): Observable<SysNumberSequenceCounter> {
            return this.http.get<SysNumberSequenceCounter>(`${this.baseUrl}/counters/${id}`);
      }

      getCountersBySequence(sequenceId: string): Observable<SysNumberSequenceCounter[]> {
            return this.http.get<SysNumberSequenceCounter[]>(`${this.baseUrl}/counters/by-sequence/${sequenceId}`);
      }

      createCounter(dto: SysNumberSequenceCounter): Observable<any> {
            return this.http.post(`${this.baseUrl}/counters`, dto);
      }

      updateCounter(id: string, dto: SysNumberSequenceCounter): Observable<any> {
            return this.http.put(`${this.baseUrl}/counters/${id}`, dto);
      }

      deleteCounter(id: string): Observable<any> {
            return this.http.delete(`${this.baseUrl}/counters/${id}`);
      }
}